





























import Vue from 'vue'

const DefaultLayout = () => import('@morpheus/utils/admin-vue/layouts/Default.vue')
const MinimalLayout = () => import('@morpheus/utils/admin-vue/layouts/Minimal.vue')
const EmptyLayout = () => import('@morpheus/utils/admin-vue/layouts/Empty.vue')

export default Vue.extend({
  name: 'App',
  components: {
    DefaultLayout,
    MinimalLayout,
    EmptyLayout
  },
  data () {
    return {
      navigation: [
        {
          routeName: 'home',
          icon: 'dashboard',
          title: 'Dashboard'
        },
        {
          routeName: 'logs',
          icon: 'error',
          title: 'Errors'
        },
        {
          routeName: 'users',
          icon: 'group',
          title: 'Users'
        },
        {
          icon: 'apps',
          title: 'System',
          children: [
            {
              routeName: 'systemLogs',
              icon: 'error',
              title: 'Errors'
            },
            {
              routeName: 'config',
              icon: 'settings_applications',
              title: 'Config'
            },
            {
              routeName: 'admin',
              icon: 'person_outline',
              title: 'Admin'
            }
          ]
        },
        {
          routeName: 'entitlements',
          icon: 'assignment',
          title: 'Entitlements'
        },
        {
          routeName: 'products',
          icon: 'layers',
          title: 'Products'
        },
        {
          routeName: 'versions',
          icon: 'query_builder',
          title: 'Version'
        },
        {
          icon: 'work_outline',
          title: 'Redeemable Codes',
          children: [
            {
              routeName: 'pools',
              icon: 'local_mall',
              title: 'Pools'
            },
            {
              routeName: 'codesReserved',
              icon: 'card_giftcard',
              title: 'My Reservation'
            }
          ]
        },
        {
          routeName: 'codesGenerator',
          icon: 'crop_free',
          title: 'Generator'
        },
        {
          routeName: 'wallets',
          icon: 'monetization_on',
          title: 'Wallets'
        },
        {
          routeName: 'shops',
          icon: 'shopping_cart',
          title: 'Shops'
        },
        {
          routeName: 'scriptEdit',
          icon: 'code',
          title: 'Script'
        },
        {
          routeName: 'definitions',
          icon: 'bar_chart',
          title: 'Stats'
        }
      ]
    }
  },
  computed: {
    layout (): string {
      return `${(this.$route.meta && this.$route.meta.layout) || 'default'}-layout`
    }
  }
})
